import React from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import Select from 'react-select'
import CloseTimeComponent from './CloseTimeComponent'

function IntervalAuctionSettings({ handleColumnChange, columnsValues, validationResults, setRecurringInterval, recurringInterval, tableStructure }) {
  const recurringIntervalColumn = tableStructure.columns.find(column => column.name === 'recurring_interval')
  let recurringIntervalOptions = [{ label: 'None', value: null }]
  if (recurringIntervalColumn) {
    recurringIntervalOptions = [
      ...recurringIntervalOptions,
      ...recurringIntervalColumn.options.map(option => ({ label: option.label, value: option.value }))
    ]
  }

  const handleRecurringIntervalChange = e => {
    if (e.value === null) {
      setRecurringInterval(false)
      return
    }

    handleColumnChange(e, recurringIntervalColumn)
  }

  return (
    <>
      <div className="setting-item">
        <CloseTimeComponent handleColumnChange={handleColumnChange} columnsValues={columnsValues} validationResults={validationResults} />
      </div>
      <div className="setting-item">
        <Row className="g-2 align-items-center">
          <Col md="3">
            <h6>Recurring Interval</h6>
          </Col>
          <Col md>
            <Form.Check
              type="switch"
              label="Recurring Interval"
              onChange={e => {
                setRecurringInterval(e.target.checked)
              }}
              checked={recurringInterval}
            />
          </Col>
        </Row>
      </div>
      {recurringInterval && (
        <>
          <div className="setting-item">
            <Select
              id="basic-select-single"
              onChange={e => {
                handleRecurringIntervalChange(e)
              }}
              options={recurringIntervalOptions?.map(option => ({
                label: option.label,
                value: option.value
              }))}
              placeholder={recurringIntervalColumn?.placeholder}
              is
              value={[columnsValues['recurring_interval']]}
            />
          </div>
        </>
      )}
      <div className="setting-item">
        <Row className="g-2 align-items-center">
          <Col md="3">
            <h6>Forecasting</h6>
          </Col>
          <Col md>
            <Form.Check
              type="switch"
              label="Forecasting"
              onChange={e => {
                handleColumnChange(e, { name: 'forecasting', title: 'Forecasting', placeholder: 'Forecasting', type: 'boolean' })
              }}
              checked={columnsValues['forecasting'] || false}
            />
          </Col>
        </Row>
      </div>
    </>
  )
}

export default IntervalAuctionSettings
